import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Flex, Box, Text, Button, Link } from 'rebass/styled-components'
import Scroll from 'react-scroll'
import renderHTML from 'react-render-html'
import VehicleDetails from '../components/content/VehicleDetails'
import Social from '../components/general/Social'
import { saveProduct } from '../system/redux/reducers/products'

const Characteristics = ({ dispatch, data }) => {
    const scrollToForm = () => {
        Scroll.scroller.scrollTo('carFormRef', {
            duration: 800,
            smooth: true,
            offset: -50,
        })
    }
    let pdfLink = false
    if (data && data.media?.gallery?.docs && data.media.gallery.docs.length) {
        const file = data.media.gallery.docs[0]
        const baseUrl = process.env.GATSBY_CLOUDINARY_IMAGE_URL
        const filepath = file.filepath + file.filename.replace(/[(]/g, '_').replace(/[)]/g, '')
        pdfLink = baseUrl + filepath
    }

    useEffect(() => {
        const prodData = JSON.stringify(data)
        dispatch(saveProduct(prodData))
    }, [data])
    return (
        data ?
            <>
                <VehicleDetails
                    chassis={data.characteristics.chassis}
                    engine={data.characteristics.engine}
                    category={data.saleProfileStatus && data.saleProfileStatus[0]}
                />
                <Flex
                    flexDirection={['column', 'row', 'row', 'row', 'column', 'column', 'row']}
                    alignContent="flex-start"
                    alignItems="flex-start"
                    flexWrap="wrap"
                    justifyContent="center"
                    mb="sm"
                    mt="lg"
                >
                    <Box
                        flexBasis="50%"
                        mb="sm"
                        pr={['0', 'xxs', 'xxs', 'xxs', '0', '0', 'xxs']}
                    >
                        <Button variant="primary_alt_alt" onClick={()=> scrollToForm()}
                            sx={{
                                backgroundColor: 'white',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                minWidth: '100%',
                            }}>Email Enquiry</Button>
                    </Box>
                    <Box
                        flexBasis="50%"
                        mb="sm"
                        pl={['0', 'xxs', 'xxs', 'xxs', '0', '0', 'xxs']}
                    >
                        <Link href="tel:+41227401939">
                            <Button variant="primary_alt_alt"
                                sx={{
                                    backgroundColor: 'white',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    minWidth: '100%',
                                }}>+41 22 740 1939</Button>
                        </Link>
                    </Box>
                    {
                        pdfLink ?
                            <Box
                                flexBasis="100%"
                                mb="sm"
                            >
                                <Link href={pdfLink} target="_blank">
                                    <Button variant="primary_alt_alt" sx={{
                                        backgroundColor: 'white',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                        minWidth: '49%',
                                    }}>View PDF</Button>
                                </Link>
                            </Box> :
                            null
                    }
                </Flex>
                <Social share={true} />
                <Box mt='lg'>
                    {
                        Object.entries(data.content.keypoints).map(([key, point]) => {
                            return <Text key={key} py={4} sx={{
                                borderColor: 'black',
                                borderStyle: 'solid',
                                borderWidth: '1px 0 0 0',
                            }}>{renderHTML(point || '')}</Text>
                        })
                    }
                </Box>
            </> :
            null
    )
}
function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps)(Characteristics)
